import { ShowIf } from '../../../../../../../../components/ShowIf';
import { singleStructures } from '../../../../../../constants/singleStructures';

interface UnitInformationHeaderProps {
    type: string;
    includeOccupied: boolean;
}

export const UnitInformationHeader: React.FC<UnitInformationHeaderProps> = ({ type, includeOccupied }) => {
    return (
        <div className='unit-info-header'>
            <ShowIf showIf={!singleStructures.includes(type)}>
                <div className='col unit'>
                    <strong>Unit</strong>
                </div>
            </ShowIf>
            <ShowIf showIf={includeOccupied}>
                <div className='col'>
                    <strong>Occupied</strong>
                </div>
            </ShowIf>
            <div className='col'>
                <strong>Annual Rent</strong>
            </div>
            <div className='col'>
                <strong>Square Feet</strong>
            </div>
            <div className='col'>
                <strong>Bedrooms</strong>
            </div>
            <div className='col'>
                <strong>Bathrooms</strong>
            </div>
            <div className='col'>
                <strong>Garage Bays</strong>
            </div>
        </div>
    );
};
